// [T155P3] Privacy Shares Health sub-signal
// GATED on T134-F1 (P0 unresolved): renders a "coming soon" placeholder only.
// Replace with real share list once T134-F1 ships.
import { Lock } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

export default function PrivacySharesHealth() {
  return (
    <div data-testid="privacy-shares-health" className="space-y-1">
      <div className="flex items-center gap-2">
        <Lock className="h-4 w-4 text-muted-foreground" />
        <span className="text-sm font-medium">Active Public Shares</span>
        <Badge variant="secondary" className="text-xs">Coming soon</Badge>
      </div>
      <p className="text-xs text-muted-foreground">
        Privacy controls are being hardened. Full visibility available soon.
      </p>
    </div>
  );
}
